/**
 * Card chrome for admin add/edit forms: the `Card` shell, the header (tabbed
 * via `tabs`, or a single non-interactive section header via `title`), and the
 * padded content region wrapping the fields.
 *
 * Chrome ONLY - this component must never own save actions, dirty-state /
 * unsaved-changes logic, permissions, validation rules or field layout. Those
 * stay in the page so forms remain composable rather than config-driven.
 * `AdminFormActions` continues to render BELOW the card, not inside it.
 */
import React from 'react'
import { Box, Card, CardContent } from '@mui/material'
import AdminFormTabHeader, { AdminFormTab } from './AdminFormTabHeader'
import AdminFormSectionHeader from './AdminFormSectionHeader'
import { formCardContentSx } from './adminFormChrome.styles'

export interface AdminFormCardProps {
  /** Tabbed mode: the tab row. Pair with `value` + `onChange`. */
  tabs?: AdminFormTab[]
  value?: number
  onChange?: (event: React.SyntheticEvent, next: number) => void
  /** Single-section mode: a static teal heading (omit `tabs`). */
  title?: string
  children: React.ReactNode
}

const AdminFormCard: React.FC<AdminFormCardProps> = ({ tabs, value, onChange, title, children }) => (
  <Card>
    <CardContent sx={{ p: 0 }}>
      {tabs && value !== undefined && onChange ? (
        <AdminFormTabHeader tabs={tabs} value={value} onChange={onChange} />
      ) : title ? (
        <AdminFormSectionHeader title={title} />
      ) : null}
      <Box sx={formCardContentSx}>{children}</Box>
    </CardContent>
  </Card>
)

export default AdminFormCard
